import { createSelector, createSlice } from '@reduxjs/toolkit';

import {
  AuthState,
  AuthWithPasswordAction,
  ChangeAccountAction,
  CreateAccountAction,
  EmailAuthAction,
  GoogleAuthAction,
  LogoutAction,
  PasskeyAuthAction,
  RegistrationUploadPhotoAction,
  SendAuthCodeAction,
  SetAuthCodeAction,
  SetAuthPhoneAction,
  SetAuthPhoneCodeAction,
  SetAuthStepAction,
  SetLoadingAction,
  SetLoggedAction,
  TelegramAuthAction,
  TelegramOidcAuthAction,
  TelegramRequestLinkAction,
  TelegramLinkAuthAction,
  UpdateRegistrationFormAction,
  ValidateEmailCodeAction,
} from './interface';
import { RootState } from 'store/rootReducer';
import { Sex } from '$store/models';

const initialState: AuthState = {
  currentUserId: 0,
  isLoading: true,
  isLogged: false,
  telegramLinkData: null,
  authForm: {
    step: 'phone',
    phoneCode: 7,
    phone: '',
    code: '',
  },
  registrationForm: {
    firstName: '',
    lastName: '',
    sex: Sex.MALE,
    bDate: '',
    country: null,
    city: null,
    isPhotoUploading: false,
    photo: null,
    photoId: 0,
  },
};

export const { actions, reducer } = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    init(state) {
      state.isLoading = true;
    },
    changeAccount(_, action: ChangeAccountAction) {},
    authWithPassword(_, action: AuthWithPasswordAction) {},
    setLoading(state, action: SetLoadingAction) {
      state.isLoading = action.payload;
    },
    goToCaptcha() {},
    sendAuthCode(_, action: SendAuthCodeAction) {},
    validateCode() {},
    setAuthFormStep(state, action: SetAuthStepAction) {
      state.authForm.code = '';
      state.authForm.step = action.payload;
    },
    setAuthFormPhoneCode(state, action: SetAuthPhoneCodeAction) {
      state.authForm.phoneCode = action.payload;
    },
    setAuthFormPhone(state, action: SetAuthPhoneAction) {
      state.authForm.phone = action.payload;
    },
    setAuthFormCode(state, action: SetAuthCodeAction) {
      state.authForm.code = action.payload;
    },
    updateRegistraionForm(state, action: UpdateRegistrationFormAction) {
      state.registrationForm = {
        ...state.registrationForm,
        ...action.payload,
      };
    },
    checkSubscriptionLoop() {},
    stopCheckSubscriptionLoop() {},
    createAccount(_, __: CreateAccountAction) {},
    registrationUploadPhoto(_, action: RegistrationUploadPhotoAction) {},
    setLogged(state, action: SetLoggedAction) {
      state.isLoading = false;
      state.isLogged = true;
      state.currentUserId = action.payload;
    },
    telegramAuth(_, __: TelegramAuthAction) {},
    telegramOidcAuth(_, __: TelegramOidcAuthAction) {},
    googleAuth(_, __: GoogleAuthAction) {},
    emailAuth(_, __: EmailAuthAction) {},
    validateEmailAuth() {},
    validateEmailCode(_, __: ValidateEmailCodeAction) {},
    reloadAccounts() {},
    telegramRequestLink(_, __: TelegramRequestLinkAction) {},
    setTelegramLinkData(state, action) {
      state.telegramLinkData = action.payload;
    },
    clearTelegramLinkData(state) {
      state.telegramLinkData = null;
    },
    telegramLinkAuth(_, __: TelegramLinkAuthAction) {},
    passkeyAuth(_, __: PasskeyAuthAction) {},
    logout(_, __: LogoutAction) {},
  },
});

export { reducer as authReducer, actions as authActions };

export const authSelector = (state: RootState) => state.auth;
export const authCurrentUserIdSelector = (state: RootState) => state.auth.currentUserId;

export const authIsLoggedSelector = createSelector(
  authSelector,
  ({ isLogged }) => isLogged,
);
